import styled from 'styled-components';
import {
  ShadowElevation, ShadowHarsh,
  ShadowSlight,
  TransitionConfig,
} from '../../../library/constants/styles-config';
import { ButtonBaseStyles } from '../../../library/styles/button';
import { ButtonMid } from '../../../library/styles/text';
import Colors from '../../../library/constants/colors';
import { IconBase } from '../../../library/styles/icon';

// eslint-disable-next-line import/prefer-default-export
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  max-width: ${(props) => (props.isFullWidth ? 'inherit' : '800px')};
  margin: ${(props) => (props.isFullWidth ? '16px 0' : '16px auto')};
  height: 100%;
  z-index: 11;
    
`;

export const TabMenuContainer = styled(Container)`
  max-width: 100%;
  margin: 0;
  display: flex;
  justify-content: center;
  flex-direction: row;
  padding: 16px;
  position: relative;

  > div {
    top: 71px;
    bottom: calc(100% - 111px);
    position: fixed;
    background-color: #F8F9FA;
    box-shadow: 0px 4px 5px -3px rgba(45, 49, 50, 0.2);
  }
`;

export const ButtonFileContainer = styled.div`
  width: 200px;
  display: flex;
  justify-content: space-between;
`;

export const ButtonFile = styled.label`
  ${ButtonBaseStyles};
  ${ButtonMid};
  margin: -4px 0 32px;
  box-shadow: ${ShadowSlight};
  background-color: ${Colors.shade08};
  transition: background-color ${TransitionConfig}, box-shadow ${TransitionConfig};
  display: flex;
  align-items: center;
  
  &:hover {
    background-color: ${Colors.shade07};
    box-shadow: ${ShadowHarsh};
  }
    
  span, svg {
    margin-left: 8px;
  }
    span {
        margin-right: 16px;
    }
`;

export const Icon = styled(IconBase)`
  color: ${Colors.violet};
`;

export const CloseIcon = styled(Icon)`
  cursor: pointer;
  font-weight: 900;
  margin-left: -20px;
  font-size: 42px;
`;
